/**
 * Single item inside a QC checklist template body.
 * Mirrors backend QCChecklistTemplateItem.
 */
export interface QCChecklistTemplateItem {
    readonly title: string;
    readonly hint?: string | null;
}
